import comp from "./AttachmentCard";
export default comp;
